module.exports = __webpack_public_path__ + "img/stop-circle.111902c2.svg";